/* 
Button to call a passed smart contract function
Displays any error message or else the current status of the called transaction
*/
import { Stack, Button } from "@mantine/core";

export default function SmartContractAction(props) {
  if (props.isFinished) {
    return (
      <Stack spacing={24}>
        <Button
          radius="xs"
          uppercase
          disabled
          variant="gradient"
          gradient={{ from: "#61892f", to: "#86c232", deg: 45 }}
          styles={(theme) => ({
            label: {
              color: "#afb0b3"
            }
          })}
        >
          {props.finishedMessage}
        </Button>
      </Stack>
    );
  } else if (props.txn != "") {
    return (
      <Stack spacing={24}>
        <Button
          radius="xs"
          uppercase
          disabled
          variant="gradient"
          gradient={{ from: "#61892f", to: "#86c232", deg: 45 }}
          styles={(theme) => ({
            label: {
              color: "#afb0b3"
            }
          })}
        >
          Transaction submitted...
        </Button>
      </Stack>
    );
  } else if (props.isPending) {
    return (
      <Stack spacing={24}>
        <Button
          radius="xs"
          uppercase
          disabled
          variant="gradient"
          gradient={{ from: "#61892f", to: "#86c232", deg: 45 }}
          styles={(theme) => ({
            label: {
              color: "#afb0b3"
            }
          })}
        >
          {props.pendingMessage}
        </Button>
      </Stack>
    );
  } else {
    return (
      <Stack spacing={24}>
        <Button
          radius="xs"
          uppercase
          onClick={() => props.action()}
          variant="gradient"
          gradient={{ from: "#61892f", to: "#86c232", deg: 45 }}
        >
          {props.actionMessage}
        </Button>
      </Stack>
    );
  }
}
